import { render, staticRenderFns } from "./SettingShow.vue?vue&type=template&id=6bc4de93&"
import script from "./SettingShow.vue?vue&type=script&lang=js&"
export * from "./SettingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports